import { render } from "./ProductCategoriesDataList.vue?vue&type=template&id=28efe697&scoped=true"
import script from "./ProductCategoriesDataList.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesDataList.vue?vue&type=script&lang=js"

import "./ProductCategoriesDataList.vue?vue&type=style&index=0&id=28efe697&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28efe697"]])

export default __exports__